import { render } from "./TransitionFade.vue?vue&type=template&id=173d60bc"
const script = {}

import "./TransitionFade.vue?vue&type=style&index=0&id=173d60bc&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__